import { useMemo } from "react";
import { useFormik } from "formik";
import { TextArea } from "../atoms/TextArea";
import { t } from "i18next";
import { SelectAvatar } from "./SelectAvatar";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { DialogCreate } from "../molecules/DialogCreate";
import { useUpdateTicketMutation } from "@/pages/RecoveryPage/api/recovery.api.";
import { toasts } from "@/shared/utils/toasts";
import { Select } from "./Select";

const ticketStatus = [
  {
    id: "No Read",
    value: "No Read",
    name: "No leído",
    element: "No leído",
  },
  {
    id: "Finished",
    value: "Finished",
    name: "Terminado",
    element: "Terminado",
  },
  {
    id: "Read",
    value: "Read",
    name: "Leído",
    element: "Leído",
  },
  {
    id: "Technical Support",
    value: "Technical Support",
    name: "Soporte técnico",
    element: "Soporte técnico",
  },
];

const IncidenceModal = ({ open, setOpen, data, usersSupportStaff }) => {
  const [updateTicket, { isLoading }] = useUpdateTicketMutation();

  const support = useMemo(() => {
    if (!data?.support_id) return null;

    const userSupport = usersSupportStaff.find(
      (value) => value.id == data.support_id
    );

    console.log({ userSupport });

    return userSupport ?? null;
  }, [usersSupportStaff, data?.support_id]);

  const formikForm1 = useFormik({
    initialValues: {
      subject: data?.subject,
      description: data?.message,
      support: support,
      status: data?.status,
    },
    //validationSchema: validationSchemaTickets,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        await updateTicket({
          id: data?.id,
          subject: values.subject,
          message: values.description,
          status: values.status,
          support_id: usersSupportStaff.find(
            (value) => value.id == values.support.id
          )?.id,
        }).unwrap();
        setOpen(false);
        toasts.success(
          "Actualziacion",
          "Se ha actualziado el ticker exitosamente"
        );
      } catch (error) {
        console.error(error);
        toasts.danger("Error", "No se ha actualizado el ticket");
      }
    },
  });

  return (
    <DialogCreate
      open={open}
      setOpen={setOpen}
      OnclickCancel={() => setOpen(false)}
      tittle={t("share.views.generate_incident")}
      tittleButtonCancel={t("general.cancel")}
      tittleButtonCreate={t("general.save")}
      OnclickCreate={() => formikForm1.handleSubmit()}
      isLoading={isLoading}
      acceptDisabled={isLoading}
    >
      <div>
        <form className="mt-6 mx-2">
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.info_incident")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("lead.views.tittle")}
                    span={t("general.mandatory")}
                    id="title"
                    name="title"
                    type="text"
                    placeholder={t("user.views.name")}
                    value={formikForm1.values.subject}
                    onChange={formikForm1.handleChange}
                    onBlur={formikForm1.handleBlur}
                    error={
                      formikForm1.touched.subject && formikForm1.errors.subject
                    }
                    textError={formikForm1.errors.subject}
                  />
                </div>
                <div className="col-span-full">
                  <SelectAvatar
                    tittle={t("share.views.assign")}
                    span={t("general.optional")}
                    selected={usersSupportStaff.find(
                      (value) => value.id == formikForm1.values?.support?.id
                    )}
                    setSelected={(value) => {
                      console.log({ value });
                      formikForm1.setFieldValue("support", value);
                    }}
                    options={usersSupportStaff}
                  />
                </div>
                <div className="col-span-full">
                  <Select
                    tittle="Estado"
                    name="Estado"
                    setSelected={(value) => {
                      formikForm1.setFieldValue("status", value.id);
                    }}
                    selected={
                      ticketStatus.find(
                        (opt) => opt.id === formikForm1.values.status
                      ) || ticketStatus[0]
                    }
                    options={ticketStatus?.map((option) => {
                      return {
                        id: option.id,
                        name: option.element,
                      };
                    })}
                  />
                </div>
                <div className="col-span-full">
                  <TextArea
                    htmlFor="description"
                    label={t("bond.views.description")}
                    spanMessage={t("general.optional")}
                    value={formikForm1.values.description}
                    onChange={(value) =>
                      formikForm1.setFieldValue(
                        "description",
                        value.target.value
                      )
                    }
                    onBlur={formikForm1.handleBlur}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </DialogCreate>
  );
};

export default IncidenceModal;
